export const buildClientPreviewLineItems = (scopeOfWork: any) => {
  if (!scopeOfWork?.areasByScopesOfWork || !Array.isArray(scopeOfWork.areasByScopesOfWork)) {
    return [];
  }

  const typeOfService = scopeOfWork.typeOfService;

  return scopeOfWork.areasByScopesOfWork.map((area: any) => {
    let price = 0;

    if (typeOfService?.areas && Array.isArray(typeOfService.areas)) {
      const serviceArea = typeOfService.areas.find((sa: any) => sa.AreaByTypeOfService?.areaUid === area.areaUid);

      if (serviceArea?.AreaByTypeOfService?.cost?.value) {
        price = Number(serviceArea.AreaByTypeOfService.cost.value) || 0;
      }
    }

    const quantity = Number(area?.quantity) || 0;

    const taskDetails = area?.tasks
      ?.map((t: any) => t?.name)
      .filter(Boolean)
      .join(", ");

    return {
      id: area.uid,
      description: area?.area?.name || "Unknown Area",
      details: taskDetails || area?.area?.description || "",
      quantity,
      price,
      total: price * quantity,
    };
  });
};
